const listeners = new Set();

export const subscribeNovitaState = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const emitNovitaState = (state) => {
  listeners.forEach((listener) => listener(state));
};
